module.exports = __webpack_public_path__ + "img/Artboard 4.2f808367.png";